import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import too_hot from "../../assets/images/covert_art/too_hot.png";
import too_hot_video from "../../assets/videos/too_hot_video.mov";
import "../../assets/styles/NewestSingle.css";

export default function NewestSingle() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsModalOpen(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = "unset";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isModalOpen]);

  return (
    <MDBContainer id="newest_single" className="newest-single-container" fluid>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", textAlign: "center" }}>

        {/* Cover Art Wrapper with Hover Effect and Play Overlay */}
        <div
          className="cover-art-wrapper"
          onClick={() => setIsModalOpen(true)}
          style={{ cursor: "pointer", position: "relative", overflow: "hidden", borderRadius: "12px", boxShadow: "0 8px 24px rgba(0,0,0,0.3)", marginBottom: "20px" }}
        >
          <img
            src={too_hot}
            alt="TOO HOT"
            className="too-hot-img"
          />
          <div className="play-overlay">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="white" className="play-icon-svg">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>

        <div className="newest-single-header">
          <a
            href="https://distrokid.com/hyperfollow/tiro9/too-hot?utm_campaign=website&utm_medium=Email+&utm_source=SendGrid"
            target="_blank"
            rel="noopener noreferrer"
            className="newest-single-link"
          >
            "TOO HOT" OUT NOW!
          </a>
        </div>
      </div>

      {/* Modal Dialog */}
      {isModalOpen && (
        <div className="custom-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="custom-modal-close" onClick={() => setIsModalOpen(false)} aria-label="Close dialog">
              &times;
            </button>
            <div className="custom-modal-body">
              {/* Left Column: Video */}
              <div className="custom-modal-video-wrapper">
                <video
                  src={too_hot_video}
                  controls
                  autoPlay
                  playsInline
                  className="custom-modal-video"
                />
              </div>

              {/* Right Column: Text Information */}
              <div className="custom-modal-info">
                <h3 className="modal-title">TOO HOT</h3>
                <h4 className="modal-subtitle">TIRO feat. PHIIYAH</h4>

                <p className="modal-paragraph">
                  “Too Hot” introduces a darker, more refined chapter for Nigerian-Canadian artist TIRO, joined by fellow Canadian artist PHIIYAH for a melodic hip-hop/R&B collaboration built around late-night emotions, desire, and the complexities of modern relationships.
                </p>
                <p className="modal-paragraph">
                  Blending melodic rap with alternative R&B over atmospheric trap-soul production, the record explores missed calls, emotional distance, and the tension that lingers when feelings remain unresolved. The result is a moody, cinematic sound that feels equally suited for solitary late-night drives and crowded city lights.
                </p>
                <p className="modal-paragraph">
                  Produced by JPDrown and engineered by OP, “Too Hot” brings together an all-Canadian creative team while marking TIRO’s official rebrand and return as an artist. Supported by visual storytelling, media outreach, and collaborative promotion, the release serves as the beginning of a new era—one that reflects both TIRO’s Nigerian roots and Canadian upbringing through a modern, genre-blending approach to hip-hop and R&B.
                </p>

                <div className="modal-release-date">
                  <a
                    href="https://distrokid.com/hyperfollow/tiro9/too-hot?utm_campaign=website&utm_medium=Email+&utm_source=SendGrid"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="modal-release-link"
                  >
                    OUT NOW!
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </MDBContainer>
  );
}


